import { required } from 'AppReact/schema';

export const option = {
  comment_required: required('boolean'),
  id: required('integer'),
  index: required('integer'),
  is_completion: required('boolean'),
  is_na: required('boolean'),
  name: required('string'),
}
